export default "__VITE_ASSET__BokzXFL2__"